import * as styles from "./PeopleGroup.css";

import type { JSX } from "react";

import { Skeleton } from "@frontend/components/atoms/Skeleton";

/** A card while the list it reads its person from is still loading. */
export function PersonCardSkeleton(): JSX.Element {
  return (
    <div className={styles.card}>
      <div className={styles.skeletonBody}>
        <Skeleton radius="full" className={styles.skeletonAvatar} />

        <div className={styles.skeletonIdentity}>
          <Skeleton className={styles.skeletonName} />

          <Skeleton className={styles.skeletonMeta} />
        </div>
      </div>
    </div>
  );
}
